import Icon from '../components/Icon.vue'

Icon.register({
  spider: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M151.2 167.4l-27.2-54.3c-1.9-3.7-3.4-10.1-3.4-14.3 0-2.9 0.7-7.4 1.6-10.1l25.9-77.7c2.8-8.4 11.9-12.9 20.2-10.1l15.2 5.1c8.4 2.8 12.9 11.9 10.1 20.2l-23.8 71.4 20.3 40.6c-1.4 4.2-2.5 8.2-3.2 11.8l-5.2 26.1h-4.7zM573.3 349.4c4.9 7.4 2.9 17.3-4.4 22.2l-13.3 8.9c-7.3 4.9-17.3 2.9-22.2-4.4l-48-72h-47.1l60.8 97.3c3.2 5.1 4.9 11 4.9 17v77.7c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-73.1l-74.1-118.5c1 14 2.1 28.1 2.1 42.2 0 53.1-40.8 101.4-96 101.4s-96-48.4-96-101.4c0-14.1 1.1-28.2 2.1-42.2l-74.1 118.5v73.1c0 8.8-7.2 16-16 16h-16c-8.8 0-16-7.2-16-16v-77.7 0c0-5.1 2.2-12.7 4.9-17l60.8-97.3h-47.1l-48 72c-4.9 7.4-14.8 9.3-22.2 4.4l-13.3-8.9c-7.4-4.9-9.3-14.8-4.4-22.2l52.7-79.1c5.2-7.9 17.2-14.2 26.6-14.3h77.9l-69-24.3c-5.8-1.9-13.1-7.6-16.5-12.6l-53.6-80.4c-4.9-7.4-2.9-17.3 4.4-22.2l13.3-8.9c7.4-4.9 17.3-2.9 22.2 4.4l50.6 75.8 60.5 20.2h36.1l10.4-51.8c2.2-11 17.4-60.2 69.6-60.2s67.4 49.2 69.6 60.2l10.4 51.8h36.1l60.5-20.2 50.6-75.8c4.9-7.3 14.8-9.3 22.2-4.4l13.3 8.9c7.3 4.9 9.3 14.8 4.4 22.2l-53.6 80.4c-3.4 5-10.8 10.7-16.5 12.6l-69 24.4h77.9c9.5 0 21.4 6.4 26.6 14.3zM406.1 97.5l-23.8-71.4c-2.8-8.4 1.7-17.4 10.1-20.2l15.2-5.1c8.4-2.8 17.5 1.7 20.2 10.1l25.9 77.7c0.9 2.7 1.6 7.3 1.6 10.1 0 4.2-1.5 10.6-3.4 14.3l-27.2 54.3-25.9 8.7h-4.7l-5.2-26.1c-0.7-3.6-1.8-7.6-3.2-11.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spider.js
// module id = 1934
// module chunks = 0